import ReservationDataStore from '../../datastores/ReservationDataStore';

export default class ReservationDataStoreMock implements ReservationDataStore {
  getCampusTablets() {
    const data = {};

    return data;
  }

  getDatesTablet() {
    const data = {};

    return data;
  }

  getDatesComputer() {
    const data = {};

    return data;
  }

  subscribeResourceTablet() {
    const data = { idReservation: 100, status: 'OK' };

    return data;
  }

  subscribeResourceComputer() {
    const data = { idReservation: 100, status: 'OK' };

    return data;
  }

  getTabletDetail() {
    return {
      // data: {
      // resources: {
      reservationDetail: {
        id: '1172',
        type: 'T',
        resourceName: 'Reserva de tablet',
        date: 1677196800000,
        hourStart: '07:00',
        hourEnd: '08:00',
        ubication: 'Biblioteca Lima Centro- Torre Arequipa',
        campus: 'Lima Centro',
        flat: 'Piso 3',
        address: 'Av. Arequipa 265 y 279, Lima',
        canBeOverridden: true,
        toleranceTime: 15
      }
      // }
      // }
    };
  }

  cancelReservation() {
    return {
      data: {
        cancelSubscriptionResourceTablet: {
          cancelled: true,
          typeError: 0,
          messageError: 'OK'
        }
      }
    };
  }

  getSubscribedsTablets() {
    const data = {
      resources: {
        subscribeds: [
          {
            id: '3001',
            type: 'C',
            date: 1679406400000,
            hourStart: '14:00',
            hourEnd: '11:00',
            ubication: 'Lima Computer'
          },
          {
            id: '3002',
            type: 'C',
            date: 1678406400000,
            hourStart: '14:00',
            hourEnd: '11:00',
            ubication: 'Lima Computer'
          },
          {
            id: '1192',
            type: 'T',
            date: 1678406400000,
            hourStart: '14:00',
            hourEnd: '11:00',
            ubication: 'Lima Tablet'
          }
        ]
      }
    };

    return data.resources;
  }

  getStatusResource() {
    return {
      status: [
        {
          type: 'T',
          status: 'OK',
          message: 'Tablet is OK'
        },
        {
          type: 'C',
          status: 'OK',
          message: 'Computer is OK'
        }
      ],
      penalties: [
        {
          type: 'T',
          penaltie: false
        },
        {
          type: 'C',
          penaltie: false
        }
      ]
    };
  }
}
